import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from 'components/utils/colors'

const StyledHtmlContent = styled.div`
  color: ${colors.secondary20};
  white-space: initial;
  font-size: 14px;
  line-height: 24px;

  strong {
    font-weight: bold;
  }

  p:not(:last-child) {
    padding-bottom: 16px;
  }

  em {
    font-style: italic;
  }

  table {
    margin-bottom: 16px;
  }

  tr, td {
    padding: 8px 16px;
    border: 1px solid ${colors.secondary70};
    white-space: initial;
    line-height: 16px;
  }

  ul, ol {
    padding: 0px 0px 16px 32px;
  }

  ul {
    list-style: initial;
  }

  ol {
    list-style: decimal;
  }

  a {
    font-weight: 600;
  }
`

// NOTE: We sanitize html content on backend side
const HtmlContent = ({ html }) => {
  return (
    <StyledHtmlContent dangerouslySetInnerHTML={{ __html: html }} />
  )
}

HtmlContent.propTypes = {
  html: PropTypes.string,
}

export default HtmlContent
